<template>
  <section class="mgc-system">
    <div class="mgc-page"><div class="mgc-form-layout">
      <h1 class="mgc-heading">University sign-in</h1>
      <p v-if="loading" role="status">Checking your account…</p>
      <template v-else-if="linked">
        <h2 class="connect-intro">Your account is connected</h2>
        <p>You can use university sign-in to open this MGC account. Connecting does not change your password settings or permissions.</p>
      </template>
      <template v-else-if="eligible">
        <p class="connect-intro">Connect your existing MGC account</p>
        <p>Your data and permissions stay the same. Your MGC password will continue to work. Sign in with your own university account on the next screen.</p>
        <form @submit.prevent="confirm" class="connect-form">
          <label for="connect-email">MGC account</label>
          <input id="connect-email" class="mgc-input" :value="email" type="email" autocomplete="username" readonly>
          <template v-if="!challengeId">
            <label for="connect-password">Confirm your MGC password</label>
            <input id="connect-password" ref="password" v-model="password" class="mgc-input" type="password" autocomplete="current-password" required :disabled="busy" :aria-invalid="error ? 'true' : null" :aria-describedby="error ? 'connect-error' : null">
          </template>
          <template v-else>
            <p>Your account uses MGC verification. Enter the code sent to {{ email }}.</p>
            <label for="connect-code">Verification code</label>
            <input id="connect-code" ref="code" v-model="code" class="mgc-input" inputmode="numeric" autocomplete="one-time-code" pattern="[0-9]{6}" maxlength="6" required :disabled="busy" :aria-invalid="error ? 'true' : null" :aria-describedby="error ? 'connect-error' : null">
          </template>
          <p v-if="error" id="connect-error" role="alert">{{ error }}</p>
          <button class="mgc-button" type="submit" :disabled="busy">{{ busy ? 'Connecting…' : challengeId ? 'Verify and continue' : 'Continue with university' }}</button>
        </form>
        <button v-if="challengeId && !busy" type="button" class="connect-reset" @click="restart">Start again with your password</button>
      </template>
      <template v-else>
        <p>University sign-in cannot be connected here for this account. Continue using your existing sign-in, or contact your MGC administrator.</p>
        <p v-if="error" role="alert">{{ error }}</p>
        <button type="button" class="mgc-button" @click="load">Check again</button>
      </template>
      <router-link class="connect-back" to="/admin/choose">Back to MGC</router-link>
    </div></div>
  </section>
</template>
<script>
import axios from 'axios';
import { linkingStatus, beginLink } from '../../api/selfServiceLink';
import '../../styles/mgc-system.css';
export default {
  data: () => ({ loading: true, linked: false, eligible: false, email: '', password: '', challengeId: '', code: '', busy: false, error: '' }),
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const status = await linkingStatus();
        this.linked = status.linked === true;
        this.eligible = status.eligible === true;
        this.email = status.email || '';
      } catch (_) { this.error = 'We could not check your account. Please try again.'; }
      finally { this.loading = false; }
    },
    restart() { this.challengeId = ''; this.code = ''; this.error = ''; this.$nextTick(() => this.$refs.password.focus()); },
    async confirm() {
      if (this.busy) return;
      this.busy = true;
      this.error = '';
      try {
        const { data } = this.challengeId
          ? await axios.post('/login/mfa', { challenge_id: this.challengeId, code: this.code })
          : await axios.post('/login', { email: this.email, password: this.password });
        this.password = '';
        this.code = '';
        if (data.mfa_required) {
          this.challengeId = data.challenge_id;
          this.$nextTick(() => this.$refs.code.focus());
        } else {
          await beginLink(data.tokens.token);
        }
      } catch (error) {
        this.error = error.response?.data?.error || error.message || 'We could not connect your account. Please try again.';
      } finally { this.busy = false; }
    },
  },
};
</script>
<style scoped>
.connect-intro { margin: 16px 0; font-size: 20px; font-weight: 600; }
.connect-form { display: grid; gap: 12px; margin-top: 24px; }
.connect-back, .connect-reset { display: block; width: fit-content; margin-top: 20px; padding: 10px 0; min-height: 44px; color: #1d4ed8; text-decoration: underline; }
.connect-back:focus-visible, .connect-reset:focus-visible { outline: 2px solid #1d4ed8; outline-offset: 3px; }
</style>
